module.exports = __webpack_public_path__ + "assets/img/bed.31421c28.png";